<template>
    <div class="page bgF6F6F6">

        <div style="height: 30px; line-height: 30px;" v-show="view=='normal'">
            <header class="pageHeader detailPageHeader paddingH16 paddingV8 white_bg">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body" style="margin-top: 10px; padding-bottom: 170px;" v-show="view=='normal'">
            <div class="">

                <div class="formRow clearfix" style="padding: 20px 10px; line-height: 50px">
                    <div class="columnName">
                        <div class="imageArea circle hiddenOverflow" style="width: 50px; height: 50px;">
                            <img class="circle block fullSpace cover" :src="dataItem.headerImg"
                                 v-if="dataItem.headerImg"/>
                        </div>

                    </div>
                    <div class="columnValue">
                        <label class="inlineBlock">
                            修改头像
                            <i class="fa fa-angle-right"></i>
                            <input type="file" class="hidden" @change="onChangeHeadImg"/>
                        </label>
                    </div>
                </div>

                <div class="formRow clearfix marginT10">
                    <div class="columnName">账号</div>
                    <div class="columnValue copyAction" :data-clipboard-text="dataItem.introduceCode">
                        {{dataItem.introduceCode}}
                    </div>
                </div>

                <div class="lineF0F0F0"></div>

                <div class="formRow clearfix">
                    <div class="columnName">手机号</div>
                    <div class="columnValue" >
                        <template v-if="dataItem.phone">
                            <span @click="showPhone=!showPhone">
                                {{showPhone ? dataItem.phone : dataItem.phone.substr(0,3) + '****' + dataItem.phone.substr(7, 4)}}
                            </span>
                        </template>
                        <router-link to="/me/bindPhone" v-else>
                            未绑定
                        </router-link>

                    </div>
                </div>

                <div class="formRow clearfix">
                    <div class="columnName">身份证</div>
                    <div class="columnValue" >
                        <template v-if="dataItem.idCardNumber">
                            已认证
                        </template>
                        <router-link class="color9D9E9D" to="/me/idCardAuth" v-else>
                            去认证
                            <i class="fa fa-angle-right"></i>
                        </router-link>

                    </div>
                </div>

                <div class="lineF0F0F0"></div>

                <div class="formRow clearfix">
                    <div class="columnName">昵称</div>
                    <div class="columnValue">
                        <input class="inputbox" type="text" style="width: 120px" v-model="dataItem.userName"
                               @change="save()"/>
<!--                        <i class="fa fa-angle-right"></i>-->
                    </div>
                </div>

                <div class="lineF0F0F0"></div>

                <div class="formRow clearfix">
                    <div class="columnName">性别</div>
                    <div class="columnValue">
                        <select class="selectbox" type="text" v-model="dataItem.sex"
                               @change="save()">
                            <option value="">未设置</option>
                            <option :value="sexItem.code" v-for="sexItem in sexList" :key="sexItem.code">
                                {{sexItem.title}}
                            </option>
                        </select>
<!--                        &nbsp;-->
<!--                        <i class="fa fa-angle-right"></i>-->
                    </div>
                </div>

                <div class="lineF0F0F0"></div>

                <div class="formRow clearfix marginB24">
                    <div class="columnName">生日</div>
                    <div class="columnValue">
                        <input type="date" class="inputbox" v-model="dataItem.birthday" format="YYYY-MM-DD" @change="save()"/>
<!--                        <i class="fa fa-angle-right"></i>-->
                    </div>
                </div>

                <div class="formRow clearfix">
                    <div class="columnName">学习喜好</div>
                    <div class="columnValue">
                        <div @click="view='hobby'">
                            点击选择
                            <i class="fa fa-angle-right"></i>
                        </div>
                    </div>
                </div>

                <div class="lineF0F0F0"></div>

                <div class="formRow clearfix">
                    <div class="columnName">学历</div>
                    <div class="columnValue">
                        <template>
                            <select class="selectbox" type="text" v-model="dataItem.educationBackground"
                                    @change="save()">
                                <option value="">点击设置</option>
                                <option :value="eduItem.value" v-for="eduItem in eduList" :key="eduItem.value">{{eduItem.name}}</option>
                            </select>
<!--                            点击设置-->
<!--                            <i class="fa fa-angle-right"></i>-->
                        </template>
                    </div>
                </div>

                <div class="lineF0F0F0"></div>

                <div class="formRow clearfix">
                    <div class="columnName">职业</div>
                    <div class="columnValue">
                        <div @click="view='profession'">
                            添加你的职业
                            <i class="fa fa-angle-right"></i>
                        </div>
                    </div>
                </div>

                <div class="formRow clearfix" style="margin-top: 22px">
                    <div class="columnName" style="float: none; width: auto;">个性签名</div>
                    <div class="columnValue" style="float: none; width: auto;">
<!--                        <input class="inputbox" type="text" style="width: 120px" v-model="dataItem.signature"-->
<!--                            placeholder="未填写"-->
<!--                               @change="save()"/>-->
                        <textarea class="inputbox" style="text-align: left; display: block; width: 100%; min-height: 80px;"
                            placeholder="未填写" v-model="dataItem.signature"
                            @change="save()"></textarea>

                    </div>
                </div>

            </div>
        </div><!-- end .body -->

        <!-- 选择学习喜好 -->
        <div style="height: 46px; line-height: 46px;" v-show="view=='hobby'">
            <header class="pageHeader detailPageHeader paddingH16 white_bg bottomBorderFAFAFA">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 40px">
                            <span class="floatL font14r" @click="view='normal'">取消</span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold">
                            选择学习喜好（{{hobbySelectedIds.length}}/{{hobbyLimit}}）
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 40px">
                            <span style="color: #F4950E;" @click="saveHobby()">确定</span>
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <!-- 选择学习喜好 -->
        <div class="body white_bg" style="margin-top: 10px;" v-show="view=='hobby'">
            <div class="paddingH8 paddingV16">
                <template v-for="l1hobbyItem in hobbyList">
                    <div class="font14r marginB12">{{l1hobbyItem.name}}</div>
                    <div class="gridLayout grid4column gridColumnGap8 gridRowGap8 marginB12">
                        <div class="l2hobbyItem font14r" :class="{active : isSelectedHobby(l2hobbyItem)}"
                             v-for="l2hobbyItem in l1hobbyItem.subCategory" @click="selectHobby(l2hobbyItem)">
                            {{l2hobbyItem.name}}
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- 选择职业 -->
        <div style="height: 46px; line-height: 46px;" v-show="view=='profession'">
            <header class="pageHeader detailPageHeader paddingH16 white_bg bottomBorderFAFAFA">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 40px">
                            <span class="floatL font14r" @click="view='normal'">取消</span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold">
                            职业
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 40px">
                            <span style="color: #F4950E;" @click="saveProfession()">确定</span>
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <!-- 选择职业 -->
        <div class="body white_bg" style="margin-top: 10px;" v-show="view=='profession'">
            <div class="paddingH8">
                <div class="font14r paddingV8" :class="{active : professionSelectedId == professionItem.value}"
                     style="border-bottom: solid 1px #EEEEEE"
                     v-for="(professionItem, index) in professionList" :key="index"
                     @click="professionSelectedId = professionItem.value; ">
                    <span>{{professionItem.name}}</span>
                    <i class="fa fa-check fr" style="color: rgb(244, 149, 14); margin-top: 3px;"
                       v-show="professionSelectedId == professionItem.value"></i>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

import moment from 'moment';

// config
import appConfig from '@/appConfig';

// api
import fileApi from '@/api/file';
import userApi from '@/api/user';
import sexEnum from '@/data/sexEnum';

// util
import appHelper    from '@/util/appHelper';
import arrayHelper    from '@/util/arrayHelper';
import consoleApi   from '@/components/platformApi/consoleApi';
import ClipboardJS from "clipboard";

const config = {
    name : 'myProfile',
    title : '个人认证',
    description : '',
    apiConfig : {
        get : {
            url : 'portal/v4/user/center/getUserInfo'
        },
        update : {
            url : 'portal/user/user/update/v2021',
            method : 'PUT'
        }
    },
    hobbyListDemo: [{
        title : '心灵成长',
        childrens : [{
            title : '亲子',
            id : '亲子',
        },{
            title : '亲密关系',
            id : '亲密关系',
        },{
            title : '情绪管理',
            id : '情绪管理',
        },{
            title : '心理学',
            id : '心理学',
        },{
            title : '家庭教育',
            id : '家庭教育',
        },]
    },{
        title : '个人提升',
        childrens : [{
            title : '投资管理',
            id : '投资管理',
        },{
            title : '人际沟通',
            id : '人际沟通',
        },{
            title : '时间管理',
            id : '时间管理',
        },{
            title : '学习管理',
            id : '学习管理',
        }]
    },],

    hobbyLimit : 6
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            enableDataItem : true,
            autoLoadDataItem : true,
            primaryKey : 'userId',

            // normal | hobby
            view : 'normal',

            dataItem : {
                id : '',
                headerImg : '',
                introduceCode : '',
                phone : '',
                userName : '',
                sex : '',
                birthday : '',
                educationBackground : '',
                hobbyList : '',
                profession : '',
                signature : '',
            },

            showPhone : false,
            sexList : sexEnum.getList(),

            hobbyList: [],
            hobbySelectedIds : [],

            eduList : [],
            professionList : [],
            professionSelectedId : '',

            hobbyLimit : config.hobbyLimit
        }
    },
    methods : {
        onLoadDataItem() {
            consoleApi.log('注册设备：' + this.dataItem.registerDevice);
            consoleApi.log('注册时间：' + this.formatDateTime(this.dataItem.createTime));
            consoleApi.log('最后更新时间：' + this.formatDateTime(this.dataItem.updateTime));

            if (this.dataItem.sex == null)
            {
                this.dataItem.sex = '';
            }

            if (this.dataItem.birthday == null)
            {
                this.dataItem.birthday = moment().add(-20, 'year').format('YYYY-MM-DD');
            }
            else
            {
                this.dataItem.birthday = moment(this.dataItem.birthday).format('YYYY-MM-DD');
            }

            if (this.dataItem.educationBackground == null)
            {
                this.dataItem.educationBackground = '';
            }

            if (this.dataItem.profession != null)
            {
                this.professionSelectedId = this.dataItem.profession;
            }

            if (this.dataItem.hobbyList)
            {
                this.hobbySelectedIds = this.dataItem.hobbyList;
            }

        },
        onChangeHeadImg(event) {
            let target = event.currentTarget;

            let file = null;
            if (target.files.length < 1)
            {
                return;
            }

            file = target.files[0];

            fileApi.uploadImage2(file, (url) => {
                this.dataItem.headerImg = url;

                this.save();
            });
        },

        isSelectedHobby(hobbyItem) {
            return arrayHelper.existElement(hobbyItem.id, this.hobbySelectedIds);
        },
        selectHobby(hobbyItem) {

            if (arrayHelper.existElement(hobbyItem.id, this.hobbySelectedIds))
            {
                this.hobbySelectedIds = arrayHelper.removeElement(this.hobbySelectedIds, hobbyItem.id);
            }
            else
            {
                if (config.hobbyLimit && this.hobbySelectedIds.length >= config.hobbyLimit)
                {
                    appHelper.showHint('最多选择' + config.hobbyLimit + '个');
                    return;
                }

                this.hobbySelectedIds.push(hobbyItem.id);
            }
            this.$forceUpdate();
        },

        saveHobby() {
            this.view = 'normal';
            this.dataItem.hobbyList = this.hobbySelectedIds;
            this.save();
        },
        saveProfession() {
            this.view = 'normal';
            this.dataItem.profession = this.professionSelectedId;
            this.save();
        },

        beforeSubmit(data) {
            data.hobbyList = data.hobbyList.join(',');
            return data;
        },

        onSubmitSuccess() {
            appHelper.showHint('保存成功');
        }
    },
    mounted() {
        // init copy icon
        let copyAction = new ClipboardJS('.copyAction');

        copyAction.on('success', function (e) {
            consoleApi.info('Action:', e.action);
            consoleApi.info('Text:', e.text);
            consoleApi.info('Trigger:', e.trigger);
            appHelper.showHint('复制成功');

            e.clearSelection();
        });

        copyAction.on('error', function (e) {
            consoleApi.error('Action:', e.action);
            consoleApi.error('Trigger:', e.trigger);
            appHelper.showMessage('当前浏览器阻止复制，请长按微信号进行复制。');
        });

        userApi.getHobbyList((data) => {
            this.hobbyList = data;
        });

        userApi.getEduList((data) => {
            this.eduList = data.child;
        });

        userApi.getProfessionList((data) => {
            this.professionList = data;
        });

    }
}
</script>

<style lang="scss" scoped>
.color9D9E9D {
    color: #9D9E9D;
}
.formRow {
    padding: 12px 10px;
    background: white;
    .columnName {
        float: left;
        width: 50%;
        color: #101010;
        font-size: 16px;
    }
    .columnValue {
        float: right;
        width: 50%;
        color: #9D9E9D;
        text-align: right;
        font-size: 14px;
        .inputbox, .selectbox {
            font-size: 14px;
            height: 27px;
            line-height: 27px;
            border: none;
            background: transparent;
            color: #9D9E9D;
            outline: none;
            text-align: right;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
    }
}
.lineF0F0F0 {
    height: 1px;
    background: #F0F0F0;
}
.l2hobbyItem {
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    border: solid 1px #999;
    color: #999;
    text-align: center;

    &.active {
        border-color: #F4950E;
        color: #F4950E;
    }
}
</style>
